<template>
    <div class="box container">
      <div class="top_box">
        <div class="top_box_child">
          <img :src="userInfo.user_avatar" alt="" />
          <div class="top_child_childbox">
            <span>{{ userInfo.alias_name }}</span>
            <span v-if="userInfo.is_real == 2" style="color:#efa041">已实名认证</span>
            <span v-if="userInfo.is_real == 1" style="color:#4c71db;cursor: pointer;" @click="renzheng">未实名认证</span>
          </div>
        </div>
        <div class="right_box">
          <div class="btn1" @click="switchs">切换身份</div>
          <div class="btn2" @click="logout">退出登录</div>
        </div>
      </div>

      <div class="content_box">
        <div>我的应用</div>
        <div class="content_child">

          <div class="content_box_child" >
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>我的账户</span>
              <span class="sty">个人余额、资金周转</span>
            </div>
          </div>
          <div class="content_box_child" >
            <img src="../../assets/image/wodeerweima.png" alt="" />
            <div class="content_box_child_child">
              <span>我的二维码</span>
              <span class="sty">推广自己</span>
            </div>
          </div>

          <div class="content_box_child" v-if="user_type==1" @click="resume">
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>我的简历</span>
              <span class="sty">个人简历维护</span>
            </div>
          </div>


          <div class="content_box_child" @click="mycollect">
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>我的收藏</span>
              <span class="sty">个人收藏的岗位</span>
            </div>
          </div>
          <div class="content_box_child" @click="mycomplaint">
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>投诉</span>
              <span class="sty">投诉列表</span>
            </div>
          </div>

          <div class="content_box_child" @click="mycomplaint">
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>历史记录</span>
              <span class="sty">历史记录</span>
            </div>
          </div>


          <div class="content_box_child" @click="mycomplaint">
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>结算</span>
              <span class="sty">结算记录</span>
            </div>
          </div>



          <div class="content_box_child" @click="mycomplaint">
            <img src="../../assets/image/wodezhanghu.png" alt="" />
            <div class="content_box_child_child">
              <span>评价</span>
              <span class="sty">评价</span>
            </div>
          </div>

          <div class="content_box_child" @click="detail">
            <img src="../../assets/image/wodezhuye.png" alt="" />
            <div class="content_box_child_child">
              <span>我的主页</span>
              <span class="sty">修改展示信息</span>
            </div>
          </div>
          <div class="content_box_child" @click="detailred">
            <img src="../../assets/image/wodehongbao.png" alt="" />
            <div class="content_box_child_child">
              <span>我的红包</span>
              <span class="sty">红包收发记录</span>
            </div>
          </div>
          <div class="content_box_child" @click="personaldetail">
            <img src="../../assets/image/gerenxinxi.png" alt="" />
            <div class="content_box_child_child">
              <span>个人信息</span>
              <span class="sty">修改个人信息</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import { userinfo } from "@/api/apply/index";
import { exitlogin } from "@/api/login/login";
export default {
  data () {
    return {
      userInfo: {},
      user_type: "",
    };
  },
  created () {
    this.user_type = localStorage.getItem("user_type") == 2 ? 2 : 1;
    this.getUserInfo();
  },

  methods: {
    //实名认证
    renzheng(){

    },
    mycollect(){
     
       this.$router.push({ name: "member-collect",
      });
    },

    mycomplaint(){
     
     this.$router.push({ name: "member-complaint",});
    },

    

    resume(){
      this.$router.push({
        name: "member-resume",
      });
    },
    //我的红包
    detailred () {
      this.$router.push({
        name: "member-redbag",
      });
    },
    personaldetail () {
      this.$router.push({
        name: "member-detail",
      });
    },
    detail () {
      if (this.user_type == 2) {
        this.$router.push({
          name: "manager-index",
          query: { id: this.userInfo.user_app_id },
        });
      }
      if (this.user_type == 1) {
        this.$router.push({ name: "member-index", query: { id: this.userInfo.user_app_id } });
      
      }
    },
    //切换身份
    switchs () {
        this.$router.push({ name: "change-status" });
    },
    //退出登录
    exitlogins () {
      let data = {};
      exitlogin(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("退出成功");
          //清除token
          localStorage.removeItem("token");
          //跳转
          this.$router.push({ name: "login" });
        }
      });
    },
    logout () {
      this.$alert("确认退出登录吗？", "退出登录", {
        confirmButtonText: "确定",
        callback: (action) => {
          this.exitlogins();
        },
      });
    },
    getUserInfo () {
      userinfo().then((res) => {
        console.log(res);
        this.userInfo = (res && res.data) ? res.data : {};
      }).catch(() => {
        this.userInfo = {};
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  margin: auto;
  .content_box {
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 0px 13px rgba(0, 0,0, 0.15);

    min-height: 500px;
    margin-bottom: 30px;
    padding: 20px 30px;
    .content_child {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .content_box_child {
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 8px;
        padding: 15px;
        width: 150px;
        margin: 20px;
        img {
          width: 50px;
          height: 50px;
        }
        .content_box_child_child {
          cursor: pointer;
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          margin-left: 5px;
          .sty {
            color: #ccc;
            font-size: 12px;
          }
        }
      }
    }
  }
  .top_box {
    border-radius: 8px;
    background-color: #fff;
    margin: 0px 0px 15px 0px;
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 0px 13px rgba(0, 0,0, 0.15);

    .top_box_child {
      display: flex;
      align-items: center;
      img {
        border-radius: 50%;
        width: 80px;
        height: 80px;
      }
      .top_child_childbox {
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
        padding-left: 20px;
      }
    }
  }
  .right_box {
    display: flex;
    align-items: center;
    .btn1 {
      cursor: pointer;
      margin-left: 20px;
      margin-right: 20px;
      width: 100px;
      height: 35px;
      color: #4c71db;
      border: 1px solid #4c71db;
      border-radius: 6px;
      background-color: white;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn2 {
      cursor: pointer;
      width: 100px;
      height: 35px;
      color: white;
      border-radius: 6px;
      background-color: #4c71db;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
